import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { KUBERNETES_PATHS } from './paths';

/**
 * Штурвал Kubernetes — общепринятая пиктограмма кластера.
 * Контур из Simple Icons (CC0), viewBox 24x24, как у иконок Material UI.
 */
export const KubernetesIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {KUBERNETES_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
